import React from 'react'
import GlueButton from '../glueos-components/glue-button'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative'
  },

  icon: {
    width: '64px',
    height: '64px',
    position: 'absolute',
    left: 0
  }
}), { name: 'MuiGlueOtherLoginButton' })

const OtherLoginButton = (props) => {
  const classes = useStyles()
  return (
    <GlueButton className={classes.root} color='secondary' width={props.width} onPointerDown={props.onPointerDown}>
      <div className={classes.icon}>
        <img src={props.iconSrc} alt='' />
      </div>
      {props.children}
    </GlueButton>
  )
}

export default OtherLoginButton
